import React, { useEffect, useState } from 'react';
import { API_URL } from '../../redux/actions/types';
import { downloadAuthorizedFile } from '../../utils/downloadAuthorized';
import { useSelector, useDispatch } from 'react-redux';
import {
  Container,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Alert,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
} from 'reactstrap';
import {
  getProvider,
  getCategories,
  createReport,
} from '../../redux/actions/provider';
import { getReportDashboard } from '../../redux/actions/report';
import Loading from '../../components/Loading/Loading';
import SalesOverviewCards from './components/SalesOverviewCards';
import LeadFunnelChart from './components/LeadFunnelChart';
import TimeSeriesChart from './components/TimeSeriesChart';
import ProviderPerformanceChart from './components/ProviderPerformanceChart';
import SellerPerformanceChart from './components/SellerPerformanceChart';
import ReportFilters from './components/ReportFilters';

function Report() {
  const dispatch = useDispatch();
  const providers = useSelector((state) => state.provider.providers);
  const categories = useSelector((state) => state.provider.categories);
  const dashboardState = useSelector((state) => state.report.dashboard);
  const [loading, setLoading] = useState(true);
  const [loadingC, setLoadingC] = useState(true);
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [mandante, setmandante] = useState('');
  const [states, setStates] = useState([]);
  const [categoria, setcategoria] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [dashStart, setDashStart] = useState('');
  const [dashEnd, setDashEnd] = useState('');

  useEffect(() => {
    if (providers) {
      if (providers.message === 'Providers') {
        setLoading(false);
      }
    }
  }, [providers]);

  useEffect(() => {
    if (categories) {
      if (categories.message === 'Categories') {
        setLoadingC(false);
      }
    }
  }, [categories]);

  useEffect(() => {
    document.title = 'BGL - Reportes';
    dispatch(getCategories());
    dispatch(getProvider());
    dispatch(getReportDashboard());
  }, []);

  const onDismiss = () => setShowAlert(false);

  const onFormSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    dispatch(createReport(start, end, mandante, categoria, states));
  };

  const statusList = (status) => {
    let aux = states;
    if (aux.includes(status)) {
      aux = aux.filter((item) => item !== status);
    } else {
      aux = aux.concat(status);
    }
    setStates(aux);
  };

  const refresh = () => {
    setEnd('');
    setcategoria('');
    setmandante('');
    setStart('');
    setStates([]);
  };

  const handleDownload = async () => {
    const params = new URLSearchParams();
    params.set('start', start);
    params.set('end', end);
    params.set('category', categoria);
    params.set('provider', mandante);
    params.set('states', states.join(','));
    const today = new Date().toISOString().slice(0, 10);
    const filename = `Reporte-Bienes-${today}.xlsx`;
    await downloadAuthorizedFile({
      url: `${API_URL}/reports?${params.toString()}`,
      filename,
      onError: ({ type, status }) => {
        setAlertTitle('Error');
        setAlertMessage(
          type === 'no_token'
            ? 'Sesión expirada. Inicia sesión nuevamente.'
            : type === 'network'
              ? 'Error de red. Verifica tu conexión.'
              : `No se pudo descargar el reporte (HTTP ${status}).`,
        );
        setShowAlert(true);
      },
    });
  };

  const handleDashboardFilter = () => {
    dispatch(getReportDashboard(dashStart, dashEnd));
  };

  const dashboard = dashboardState?.data;

  return loading && loadingC ? (
    <Loading />
  ) : (
    <Container fluid className="p-4">
      <Alert isOpen={showAlert} toggle={onDismiss}>
        {alertTitle} - {alertMessage}
      </Alert>

      <h4 className="mb-4">Reportes</h4>

      {/* Dashboard Section */}
      <ReportFilters
        startDate={dashStart}
        endDate={dashEnd}
        onStartChange={setDashStart}
        onEndChange={setDashEnd}
        onFilter={handleDashboardFilter}
      />

      {dashboardState?.status === 'danger' && (
        <Alert color="danger" className="mb-3">
          {dashboardState.message || 'Error al cargar el dashboard'}
        </Alert>
      )}

      {!dashboardState && <Loading />}

      {dashboard && (
        <>
          <SalesOverviewCards overview={dashboard.overview} />

          <Row>
            <Col lg={6}>
              <LeadFunnelChart funnel={dashboard.funnel} />
            </Col>
            <Col lg={6}>
              <TimeSeriesChart timeSeries={dashboard.timeSeries} />
            </Col>
          </Row>

          <Row>
            <Col lg={6}>
              <ProviderPerformanceChart byProvider={dashboard.byProvider} />
            </Col>
            <Col lg={6}>
              <SellerPerformanceChart bySeller={dashboard.bySeller} />
            </Col>
          </Row>
        </>
      )}

      {/* Excel Export Section */}
      <Card className="mt-4">
        <CardHeader>
          <h5 className="mb-0">Exportar Reporte Excel (Bienes)</h5>
        </CardHeader>
        <CardBody>
          <Form onSubmit={(e) => onFormSubmit(e)}>
            <Row>
              <Col sm="12" lg="12">
                <FormGroup>
                  <Label for="exampleDate">Fecha de Inicio</Label>
                  <Input
                    type="date"
                    name="date"
                    id="exampleDate"
                    placeholder="date placeholder"
                    value={start}
                    onChange={(e) => setStart(e.target?.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="exampleDate">Fecha de Fin</Label>
                  <Input
                    type="date"
                    name="date"
                    id="exampleDate"
                    placeholder="date placeholder"
                    value={end}
                    onChange={(e) => setEnd(e.target?.value)}
                  />
                </FormGroup>
                <FormGroup className="col-md-12 float-left">
                  <Row className="col-md-12">
                    <Label column="true" sm="4">
                      Mandante
                    </Label>
                    <Col sm="8" className="float-right">
                      <Input
                        type="select"
                        onChange={(e) => setmandante(e.target?.value)}
                        value={mandante}
                      >
                        <option value={''}></option>
                        {providers &&
                          providers.data.map((provider, index) =>
                            provider.name !== mandante?.value ||
                            mandante?.value !== '' ? (
                              <option key={index} value={provider.name}>
                                {provider.name}
                              </option>
                            ) : (
                              <option
                                key={index}
                                selected
                                value={mandante?.value}
                              >
                                {mandante?.value}
                              </option>
                            ),
                          )}
                      </Input>
                    </Col>
                  </Row>
                  <Row className="col-md-12 mt-2">
                    <Label column="true" sm="4">
                      Categoria del Bien
                    </Label>
                    <Col lg="8" className="float-right">
                      <Input
                        type="select"
                        onChange={(e) => setcategoria(e.target?.value)}
                        value={categoria}
                      >
                        <option value={''}></option>
                        {categories &&
                          categories.data.data.map((category, index) =>
                            category.category_name !== categoria?.value ? (
                              <option
                                key={index}
                                value={category.category_name}
                              >
                                {category.category_name}
                              </option>
                            ) : (
                              <option
                                key={index}
                                selected
                                value={categoria?.value}
                              >
                                {categoria?.value}
                              </option>
                            ),
                          )}
                      </Input>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>
            <Row className="ml-3 mt-3 pb-3">
              <Col lg="3">
                <Label check>
                  <Input
                    type="checkbox"
                    value={
                      states.filter((state) => state === 'No Liberado')
                        ? false
                        : true
                    }
                    onChange={(e) => statusList('No Liberado')}
                  />{' '}
                  No Liberados
                </Label>
              </Col>
              <Col lg="3">
                <Label check>
                  <Input
                    type="checkbox"
                    onChange={(e) => statusList('Liberado')}
                  />{' '}
                  Liberados
                </Label>
              </Col>
              <Col lg="3">
                <Label check>
                  <Input
                    type="checkbox"
                    onChange={(e) => statusList('Vendido')}
                  />{' '}
                  Vendidos
                </Label>
              </Col>
              <Col lg="3">
                <Label check>
                  <Input
                    type="checkbox"
                    onChange={(e) => statusList('Devuelto')}
                  />{' '}
                  Devueltos
                </Label>
              </Col>
            </Row>
            <Button
              className="btn btn-info float-right"
              onClick={() => refresh()}
            >
              REFRESCAR
            </Button>
            <Button
              className="btn btn-primary"
              onClick={handleDownload}
            >
              GENERAR EXCEL
            </Button>
          </Form>
        </CardBody>
      </Card>
    </Container>
  );
}
export default Report;
